<template>
  <HXContentCard
    title="Gestión de auditoría de cuentas de cobro"
    :defaultToBack="true"
  >
    <!-- modal auditar archivos -->
    <b-modal
      id="auditarArchivos"
      title="Revisar documentos de cuenta de cobro"
      size="lg"
      hide-footer
      class="modal-altura-personalizada"
    >
      <div>
        <transition name="fade">
          <div v-if="isLoadingFiles" class="loading-msg">
            <span>Cargando documentos, por favor espera...</span>
          </div>
        </transition>

        <div v-for="(item, index) in itemsFiles" :key="index">
          <div class="d-flex my-2 align-items-center bg-dark pointer">
            <div style="width: 100%" @click="toggle(index)" class="bg-dark p-3">
              <div class="d-flex align-items-center">
                <i
                  class="mr-2"
                  :class="[
                    'fas',
                    isActive(index) ? 'fa-chevron-down' : 'fa-chevron-right',
                  ]"
                ></i>
                <span>{{ item.title }}</span>
              </div>
            </div>
            <div class="ml-auto d-flex align-items-center">
              <!-- soporte modificado -->
              <div class="file-modify-badge" v-if="item.estado == -1">
                <i class="ti ti-file-download" style="font-size: 1.2rem"></i>
              </div>

              <!-- acciones -->
              <vs-button
                v-if="item.url"
                transparent
                v-b-tooltip.hover
                title="Ver documento"
                icon
                @click="gotoFile(item.url)"
              >
                <i class="ti ti-eye text-white-50"></i>
              </vs-button>
              <vs-button
                v-if="item.url"
                v-b-tooltip.hover
                title="Aprobar documento"
                :loading="buttonLoading[item.id + '_approve']"
                transparent
                icon
                @click="saveNewStateGestionFile(item.id, true, 'approve')"
              >
                <i
                  :class="`ti ti-${
                    item.estado === 1 ? 'thumb-up-filled' : 'thumb-up'
                  }`"
                ></i>
              </vs-button>
              <vs-button
                v-if="item.url"
                v-b-tooltip.hover
                title="Rechazar documento"
                :loading="buttonLoading[item.id + '_reject']"
                transparent
                danger
                icon
                @click="saveNewStateGestionFile(item.id, false, 'reject')"
              >
                <i
                  :class="`ti ti-${
                    item.estado === 0 ? 'thumb-down-filled' : 'thumb-down'
                  } text-danger`"
                ></i>
              </vs-button>
            </div>
          </div>

          <transition name="fade">
            <div v-if="isActive(index)">
              <div class="d-flex flex-wrap" v-if="item.url">
                <span class="mx-2">
                  <i class="ti ti-calendar-event"></i>
                  Cargado:
                  {{ item.fechaSubida | moment("from", "now") }}
                </span>
                <span class="mx-2" v-if="item.fechaEstado">
                  <i class="ti ti-calendar-check"></i>
                  Revisado:
                  {{ item.fechaEstado | moment("from", "now") }}
                </span>
              </div>
              <ComentariosCuentaCobro
                :dataSendCommentFile="buildObjectCommentFile(item.id)"
                :commentsFiles="item.comments"
                class="div-comentario-v2"
                v-if="item.url"
              />
              <p v-else class="text-center border rounded p-3">
                <i class="ti ti-file-x text-muted" style="font-size: 2rem"></i>
                <br />
                No se ha cargado ningún documento.
              </p>
            </div>
          </transition>
        </div>
      </div>
    </b-modal>
    <!-- modal agregar fechas -->
    <b-modal
      id="agregarFecha"
      title="Configurar período de auditoría"
      size="md"
      hide-footer
    >
      <p v-if="!ultimaFecha.id">
        No hay períodos configurados para la auditoría de cuentas de cobro.
        Configura un nuevo período para habilitar la auditoría.
      </p>
      <p>
        <span class="text-danger">*</span> Esta configuración debe realizarse
        durante los primeros 10 días de cada mes.
      </p>

      <p class="text-right" v-if="ultimaFecha.id">
        <i class="ti ti-calendar-check"></i>
        Última actualización: <br />
        <strong
          v-b-tooltip
          :title="
            $moment(ultimaFecha && ultimaFecha.createdAt).format(
              'DD MMM, YYYY hh:mm a'
            )
          "
          >{{
            ultimaFecha && ultimaFecha.createdAt | moment("from", "now")
          }}</strong
        >
      </p>
      <form class="row p-2" @submit.prevent="saveNewDate">
        <div class="col-12 mb-3">
          <label for="date" class="form-label">Mes y Año</label>
          <input
            id="date"
            type="month"
            class="form-control"
            v-model="currentDate"
            @input="handleDateInput"
            required
          />
        </div>
        <div class="col-12 mb-3">
          <label for="fechaInico" class="form-label">Fecha de inicio</label>
          <input
            id="fechaInico"
            type="datetime-local"
            class="form-control"
            v-model="nuevaFecha.fechaInicio"
            required
          />
        </div>
        <div class="col-12 mb-3">
          <label for="fechaFin" class="form-label">Fecha de cierre</label>
          <input
            id="fechaFin"
            type="datetime-local"
            class="form-control"
            v-model="nuevaFecha.fechaFin"
            required
          />
        </div>

        <div class="col-12 mb-3" v-if="ultimaFecha.id">
          <vs-button type="button" @click="actualizarFechaFin">
            Actualizar fecha de cierre
          </vs-button>
        </div>

        <vs-button class="ml-auto" type="submit" v-if="!ultimaFecha.id">
          Guardar configuración
        </vs-button>
      </form>
    </b-modal>

    <div class="px-5 my-4">
      <CardTable :data="dataCards" />
    </div>
    <div class="row">
      <div
        class="col-12 col-lg-4 px-5"
        :class="{ 'col-lg-5': cargaHabilitadaActiva && tiempoRestante }"
      >
        <label for="filterDate" class="form-label"
          ><i class="ti ti-calendar-month"></i> Período:</label
        >
        <div class="d-flex align-items-center filter-container">
          <input
            id="date"
            type="month"
            class="form-control"
            style="width: 200px"
            v-model="currentFilterDate"
            @input="handleFilterDateInput"
            required
          />
          <!-- Cuenta regresiva -->
          <div
            v-if="cargaHabilitadaActiva && tiempoRestante"
            class="countdown-header ml-3"
            v-b-tooltip.hover
            title="Tiempo restante para cerrar la carga de documentos"
          >
            <i
              class="ti ti-clock mr-1 text-white-50"
              style="font-size: 1rem"
            ></i>
            <span class="countdown-text">
              {{ tiempoRestante.dias }}d {{ tiempoRestante.horas }}h
              {{ tiempoRestante.minutos }}m {{ tiempoRestante.segundos }}s
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right px-4 mt-2">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center"
        style="gap: 1rem"
      >
        <div v-show="ultimaFecha && ultimaFecha.id">
          <span> Habilitar cuenta de cobro </span>
          <VueToggles
            height="20"
            width="50"
            :value="ultimaFecha && ultimaFecha.isUploadCuentaCobro"
            @click="ToggleIsUploadCuentaCobro"
          />
        </div>
        <div class="d-flex">
          <vs-button
            icon
            primary
            class="mx-1 text-right"
            v-b-modal.agregarFecha
          >
            <i class="ti ti-calendar-check mr-1"></i>
            Configurar período
          </vs-button>
          <!-- generar reporte -->
          <vs-button
            v-if="listProfesionales.length"
            icon
            success
            class="mx-1"
            @click="generateReport"
          >
            <i class="ti ti-file-excel mr-1"></i>
            Exportar reporte
          </vs-button>
        </div>
      </div>
    </div>

    <div class="table-responsive p-4">
      <table
        id="datatable_profesionales"
        class="table table-bordered table-responsive-md table-striped text-center"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Cédula</th>
            <th>Profesional</th>
            <th>Período</th>
            <th>Documentos cargados</th>
            <th>Cuenta de cobro</th>
            <th>Artículo retención</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listProfesionales" :key="item.id">
            <td>
              <strong>
                {{ index + 1 }}
              </strong>
            </td>
            <td>{{ item.NumeroDocumento }}</td>
            <td>{{ item.Nombres }} {{ item.Apellidos }}</td>
            <td>
              <span v-if="item.Periodo !== '-'">
                {{ $moment(item.Periodo, "YYYY-MM").format("MMMM, YYYY") }}
                -
                <span
                  :class="
                    item.Estado == 1
                      ? 'badge badge-success'
                      : 'badge badge-danger'
                  "
                >
                  {{ item.Estado == 1 ? "Completado" : "Pendiente" }}
                </span>
              </span>
              <span v-else> Sin datos </span>
            </td>
            <td>
              <span class="d-none">
                {{ item.ArchivosCargados ? "arccargado" : "arcnocargado" }}
              </span>
              <i
                v-if="item.ArchivosCargados"
                class="ti ti-check text-success"
              ></i>
              <i v-else class="fas fa-times text-danger"></i>
            </td>
            <td>
              <span class="d-none">
                {{ item.IsUploadedCC ? "cdccargado" : "cdcnocargado" }}
              </span>
              <i v-if="item.IsUploadedCC" class="fas fa-check text-success"></i>
              <i v-else class="ti ti-x text-danger"></i>
            </td>
            <td>
              {{ item.CalculoArt }}
            </td>
            <td>
              <div style="display: flex; gap: 8px; justify-content: center">
                <vs-button
                  icon
                  color="#0b8f8d"
                  v-b-tooltip.hover
                  title="Configurar retención en la fuente"
                  @click="retencionEnLaFuenteModal(item)"
                >
                  <i class="ti ti-file-dollar"></i>
                </vs-button>
                <vs-button
                  icon
                  v-b-tooltip.hover
                  title="Revisar documentos"
                  @click="openAuditarModal(item.Periodo, item.Id)"
                >
                  <i class="ti ti-file-stack"></i>
                </vs-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--retención en la fuente -->
    <b-modal
      id="modal-retencion"
      :title="`Configuración de retención en la fuente`"
      size="md"
      hide-footer
    >
      <form ref="fromretencion" @submit.prevent="guardarRetencionEnLaFuente">
        <!-- historial -->
        <div class="d-flex justify-content-center mb-2">
          <vs-button
            type="button"
            icon
            size="mini"
            @click="openModalHistorialRetencion"
          >
            <i class="ti ti-history mr-1"></i>
            Ver historial
          </vs-button>
        </div>
        <div class="row px-2">
          <div class="col-12 py-2 rounded">
            <div class="row m-3">
              <div class="col-6 px-0">
                <h4 class="mb-2"><b>Mes:</b></h4>
                <b-select
                  v-model="mesSeleccionado"
                  class="form-control personalizado"
                  :options="listaMes"
                  text-field="text"
                  value-field="id"
                  required
                />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Año:</b></h4>
                <b-select
                  v-model="anioSeleccionado"
                  class="form-control personalizado"
                  :options="listaAnios"
                  required
                />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Artículo:</b></h4>
                <b-select
                  v-model="articuloSeleccionado"
                  class="form-control personalizado"
                  :options="listaArticulos"
                  required
                />
              </div>
            </div>
            <div class="px-0 mt-3 d-flex justify-content-end">
              <vs-button
                danger
                class="px-2 py-1"
                @click.prevent="$root.$bvModal.hide('modal-retencion')"
                id="sendform2"
              >
                Cancelar
              </vs-button>
              <vs-button primary class="px-2 py-1" type="submit" id="sendform3">
                Guardar configuración
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- modal historial retención-->
    <b-modal
      id="modal-historialretencion"
      title="Historial de retención en la fuente"
      size="md"
      hide-footer
    >
      <template v-if="historialRetencion.length > 0">
        <div
          class="bg-dark rounded p-3 mb-2"
          v-for="h in historialRetencion"
          :key="h.id"
        >
          <div class="d-flex align-items-center flex-wrap" style="gap: 1rem">
            <div class="col-6">
              <small class="text-muted"> Período </small>
              <br />
              <b>
                {{ listaMes[h.mes - 1].text + " - " + h.anio }}
              </b>
            </div>
            <div>
              <small class="text-muted"> Artículo seleccionado</small>
              <br />
              <b>
                {{ h.calculoArt }}
              </b>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!historialRetencion.length">
        <p>No hay registros para mostrar</p>
      </template>
    </b-modal>
  </HXContentCard>
</template>
<script>
import ComentariosCuentaCobro from "@/components/ComentariosCuentaCobro/ComentariosCuentaCobro.vue";
import Swal from "sweetalert2";
import { core } from "../../../config/pluginInit";
import CardTable from "@/components/cardTable/CardTable.vue";
import * as XLSX from "xlsx";

export default {
  components: {
    CardTable,
    ComentariosCuentaCobro,
  },
  data() {
    return {
      isLoadingFiles: false,
      currentPeriod: null,
      buttonLoading: {},
      activeIndexes: [], // Array para mantener múltiples índices activos
      itemsFiles: [
        {
          id: "",
          title: "Cuenta de cobro",
          name: "_Cuenta_de_cobro",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Declaración juramentada",
          name: "_Declaracion_juramentada",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Planilla de seguridad social",
          name: "_Planilla_de_seguridad_social",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Póliza",
          name: "_Poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Recibo de pago de la póliza",
          name: "_Recibo_de_pago_de_la_poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
      ],
      dataCards: [
        {
          title: "Pendiente",
          value: () =>
            this.listProfesionales.filter((item) => item.Estado != 1).length,
          iconName: "ban",
          color: "rgb(242, 19, 67)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            console.log("Activated");
            this.dataTableInstance.column(3).search("Incompleto").draw();
          },
          onDeactivate: () => {
            console.log("Deactivate");
            this.dataTableInstance.column(3).search("").draw();
          },
        },
        {
          title: "Completado",
          value: () =>
            this.listProfesionales.filter((item) => item.Estado == 1).length,
          iconName: "circle-check",
          color: "rgb(23, 167, 108)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            console.log("Activated");
            this.dataTableInstance.column(3).search("Completado").draw();
          },
          onDeactivate: () => {
            console.log("Deactivate");
            this.dataTableInstance.column(3).search("").draw();
          },
        },
        {
          title: "Documentos cargados",
          value: () =>
            this.listProfesionales.filter((item) => item.ArchivosCargados)
              .length,
          iconName: "file-lines",
          color: "#1A5CFF",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            console.log("Activated");
            this.dataTableInstance.column(4).search("arccargado").draw();
          },
          onDeactivate: () => {
            console.log("Deactivate");
            this.dataTableInstance.column(4).search("").draw();
          },
        },
        {
          title: "Cuenta de cobro cargada",
          value: () =>
            this.listProfesionales.filter((item) => item.IsUploadedCC).length,
          iconName: "circle-check",
          color: "rgb(255, 130, 0)",
          tipo: "shield",
          animated: "bounce",
          onActivate: () => {
            ``;
            console.log("Activated");
            this.dataTableInstance.column(5).search("cdccargado").draw();
          },
          onDeactivate: () => {
            console.log("Deactivate");
            this.dataTableInstance.column(5).search("").draw();
          },
        },
      ],
      currentFilterDate: null,
      listProfesionales: [],
      currentDate: null,
      ultimaFecha: {},
      tiempoRestante: null,
      countdownInterval: null,
      fechaCargaHabilitada: null,
      nuevaFecha: {
        anio: null,
        mes: null,
        fechaInicio: null,
        fechaFin: null,
        empresaId: null,
        isUploadCuentaCobro: false,
        createdAt: this.$moment
          .tz(new Date(), "America/Bogota")
          .format("YYYY-MM-DDTHH:mm:ss"),
      },
      ///retención en la fuente
      listaMes: [
        { id: 1, text: "Enero" },
        { id: 2, text: "Febrero" },
        { id: 3, text: "Marzo" },
        { id: 4, text: "Abril" },
        { id: 5, text: "Mayo" },
        { id: 6, text: "Junio" },
        { id: 7, text: "Julio" },
        { id: 8, text: "Agosto" },
        { id: 9, text: "Septiembre" },
        { id: 10, text: "Octubre" },
        { id: 11, text: "Noviembre" },
        { id: 12, text: "Diciembre" },
      ],
      listaAnios: [2025, 2026, 2027],
      listaArticulos: [0, 383, 392],
      mesSeleccionado: null,
      anioSeleccionado: null,
      articuloSeleccionado: null,
      personaRetencionEnLaFuente: null,
      historialRetencion: [],
    };
  },
  async mounted() {
    this.$isLoading(true);
    this.personaAct = JSON.parse(localStorage.getItem("setPersonaAct"));
    let empresaId = this.personaAct.empresa.id;

    this.currentFilterDate = this.$moment().format("YYYY-MM");

    await this.getFecha(
      empresaId,
      this.currentFilterDateFormatted.anio,
      this.currentFilterDateFormatted.mes
    );

    await this.getProfesionales(
      empresaId,
      this.currentFilterDateFormatted.anio,
      this.currentFilterDateFormatted.mes
    );

    // Iniciar cuenta regresiva
    this.iniciarCuentaRegresiva();

    //console.log(this.currentFilterDateFormatted);

    core.index();

    this.$isLoading(false);
  },
  beforeDestroy() {
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  },
  computed: {
    currentFilterDateFormatted() {
      const [anio, mes] = this.currentFilterDate.split("-");

      return {
        anio: parseInt(anio),
        mes: parseInt(mes),
      };
    },
    cargaHabilitadaActiva() {
      if (!this.fechaCargaHabilitada) return false;
      const fechaInicioConvert = this.$moment(
        this.fechaCargaHabilitada.fechaInicio
      ).tz("America/Bogota");
      let fechaFinConvert = this.$moment(this.fechaCargaHabilitada.fechaFin).tz(
        "America/Bogota"
      );
      if (fechaFinConvert.format("HH:mm:ss") === "00:00:00") {
        fechaFinConvert = fechaFinConvert.endOf("day");
      }
      const ahora = this.$moment().tz("America/Bogota");
      return ahora.isBetween(fechaInicioConvert, fechaFinConvert, null, "[]");
    },
  },

  methods: {
    iniciarCuentaRegresiva() {
      // Limpiar intervalo anterior si existe
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // Actualizar cuenta regresiva cada segundo
      this.countdownInterval = setInterval(() => {
        this.actualizarCuentaRegresiva();
      }, 1000);

      // Actualizar inmediatamente
      this.actualizarCuentaRegresiva();
    },
    actualizarCuentaRegresiva() {
      if (!this.fechaCargaHabilitada || !this.fechaCargaHabilitada.fechaFin) {
        this.tiempoRestante = null;
        return;
      }

      const fechaFin = this.$moment(this.fechaCargaHabilitada.fechaFin).tz(
        "America/Bogota"
      );
      const ahora = this.$moment().tz("America/Bogota");

      // Si la fecha de fin es 00:00:00, ajustar al final del día
      if (fechaFin.format("HH:mm:ss") === "00:00:00") {
        fechaFin.endOf("day");
      }

      const diferencia = fechaFin.diff(ahora);

      if (diferencia <= 0) {
        // Tiempo expirado
        this.tiempoRestante = null;
        return;
      }

      const duracion = this.$moment.duration(diferencia);

      this.tiempoRestante = {
        dias: Math.floor(duracion.asDays()),
        horas: duracion.hours(),
        minutos: duracion.minutes(),
        segundos: duracion.seconds(),
      };
    },
    async guardarRetencionEnLaFuente() {
      try {
        let dataRetencion = {
          PersonaId: this.personaRetencionEnLaFuente,
          Mes: this.mesSeleccionado,
          Anio: this.anioSeleccionado,
          CalculoArt: this.articuloSeleccionado,
        };
        await this.$store.dispatch("hl_post", {
          path: "Persona/CrearPersonaRetencionEnLaFuenteArt",
          data: dataRetencion,
        });
        Swal.fire(
          "¡Perfecto!",
          "La configuración de retención se guardó exitosamente.",
          "success"
        );
        this.$bvModal.hide("modal-retencion");
        let resulta = this.listProfesionales.findIndex(
          (x) => x.Id == this.personaRetencionEnLaFuente
        );
        //console.log("resulta dato modificado", resulta);
        this.listProfesionales[resulta].CalculoArt = this.articuloSeleccionado;
      } catch (error) {
        console.log("rror ", error);
        Swal.fire(
          "Error",
          "No se pudo guardar la configuración. Inténtalo de nuevo.",
          "error"
        );
      }
    },
    async openModalHistorialRetencion() {
      let res = await this.$store.dispatch("hl_get", {
        path:
          "Persona/ListaPersonaRetencionEnLaFuenteArt/" +
          this.personaRetencionEnLaFuente,
      });
      this.historialRetencion = res;
      this.$bvModal.show("modal-historialretencion");
    },
    async retencionEnLaFuenteModal(item) {
      this.mesSeleccionado = this.currentFilterDateFormatted.mes;
      this.anioSeleccionado = this.currentFilterDateFormatted.anio;
      //console.log("row-->", item);
      this.personaRetencionEnLaFuente = item.Id;
      // await this.GetNPerFechaIngRetHistoryByPerson(this.infoForPersonData.personaId);
      // this.$bvModal.show("modal-retencion");
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/ListaPersonaRetencionEnLaFuenteArt/" + item.Id,
        });
        //console.log("res", res);
        if (res && res.data) {
          //console.log("ok");
          this.listaRetencionEnLaFuente = res.data;
        } else {
          //console.log("no ok");
          this.listaRetencionEnLaFuente = [];
        }
        this.$bvModal.show("modal-retencion");
      } catch (error) {
        this.listaRetencionEnLaFuente = [];
        console.log("err", error);
      }
    },
    showToast(type, message) {
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },
    buildObjectCommentFile(archivoId) {
      //console.log(this.personaAct);

      return {
        personaId: this.personaAct.id,
        archivoId: archivoId,
      };
    },
    async saveNewStateGestionFile(archivoId, newState, action) {
      this.$set(this.buttonLoading, archivoId + "_" + action, true);
      try {
        let currentFile = this.itemsFiles.filter(
          (item) => item.id === archivoId
        )[0];

        //console.log(currentFile);
        let data = {
          auditorId: this.personaAct.id,
          archivoId: archivoId,
          estado: newState ? 1 : 0,
          fechaEstado: this.$moment
            .tz(new Date(), "America/Bogota")
            .format("YYYY-MM-DDTHH:mm:ss"),
        };

        //console.log(data);

        let res;
        if (currentFile.estado === null) {
          //console.log("ok");
          res = await this.$store.dispatch("hl_post", {
            path: "CDC/AddGestion",
            data,
          });
        } else {
          //console.log("ok");
          res = await this.$store.dispatch("hl_put", {
            path: "CDC/UpdateEstadoGestion/" + archivoId,
            data,
          });
        }

        //console.log(res);
        if (res && res.id) {
          // actualizar datos locales
          currentFile.estado = newState ? 1 : 0;
          currentFile.fechaEstado = data.fechaEstado;
          this.showToast(
            "success",
            "Estado del documento actualizado exitosamente!"
          );

          // Verificar si todos los archivos están aprobados
          const allFilesApproved = this.itemsFiles.every(
            (item) => item.estado === 1
          );

          // Actualizar el estado del período en listProfesionales
          if (this.currentPeriod) {
            const profesionalIndex = this.listProfesionales.findIndex(
              (item) => item.Periodo === this.currentPeriod
            );
            if (profesionalIndex !== -1) {
              this.listProfesionales[profesionalIndex].Estado = allFilesApproved
                ? 1
                : 0;
            }
          }
        }
      } catch (error) {
        console.error("Error al guardar cambios:", error);
        Swal.fire("Error!", "No se pudieron guardar los cambios.", "error");
      } finally {
        this.$set(this.buttonLoading, archivoId + "_" + action, false);
      }
    },
    gotoFile(url) {
      // Agregar timestamp para evitar cache del navegador
      const urlWithTimestamp = `${url}?t=${Date.now()}`;
      window.open(urlWithTimestamp);
    },
    resetItems() {
      // Resetear itemsFiles para evitar datos acumulados
      this.itemsFiles = [
        {
          id: "",
          title: "Cuenta de cobro",
          name: "_Cuenta_de_cobro",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Declaración juramentada",
          name: "_Declaracion_juramentada",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Planilla de seguridad social",
          name: "_Planilla_de_seguridad_social",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Póliza",
          name: "_Poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
        {
          id: "",
          title: "Recibo de pago de la póliza",
          name: "_Recibo_de_pago_de_la_poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
        },
      ];
    },
    async openAuditarModal(periodo, personaId) {
      //console.log(periodo, personaId);

      // Resetear itemsFiles
      this.resetItems();

      this.currentPeriod = periodo;

      this.$bvModal.show("auditarArchivos");

      // Extraer año y mes del string (por ejemplo: "2025-02")
      const [anio, mes] = periodo.split("-");

      this.isLoadingFiles = true;

      try {
        // obtener los archivos correspondientes al periodo seleccionado
        const archivos = await this.getArchivosPorPeriodo(anio, mes, personaId);
        //console.log(archivos);

        // Asocia la data obtenida a los itemsFiles
        archivos?.forEach((archivo) => {
          const nombreSinExtension = archivo.NombreArchivo.split(".")[0];
          const item = this.itemsFiles.find(
            (item) => item.name === nombreSinExtension
          );
          if (item) {
            item.id = archivo.ArchivoId;
            item.url = archivo.UrlArchivo;
            item.fechaSubida = archivo.FechaSubida;

            if (archivo.EstadoGestion !== undefined) {
              item.estado = archivo.EstadoGestion;
              item.fechaEstado = archivo.FechaEstado;
            }

            if (archivo.Observaciones !== undefined) {
              item.comments = archivo.Observaciones;
            }
          }
        });
      } catch (error) {
        console.error("Error al cargar los archivos para el periodo:", error);
      } finally {
        this.isLoadingFiles = false;
      }
    },
    toggle(index) {
      // Si el índice ya está activo, lo eliminamos; si no, lo agregamos
      const idx = this.activeIndexes.indexOf(index);
      if (idx === -1) {
        this.activeIndexes.push(index);
      } else {
        this.activeIndexes.splice(idx, 1);
      }
    },
    isActive(index) {
      return this.activeIndexes.includes(index); // Verifica si el índice está en el array de activos
    },
    async getArchivosPorPeriodo(anio, mes, personaId) {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetArchivosPorPeriodo/${personaId}/${parseInt(
            anio
          )}/${parseInt(mes)}`,
        });

        if (response.ok) {
          const data = await response.json();

          //  console.log(data);

          data.data.forEach((archivo) => {
            if (archivo.Observaciones) {
              archivo.Observaciones = JSON.parse(archivo.Observaciones);
            }
          });
          return data.data;
        }
      } catch (error) {
        console.error("Error en getArchivosPorPeriodo:", error);
        return [];
      }
    },
    async handleFilterDateInput() {
      if (!this.currentFilterDate) return;

      let empresaId = this.personaAct.empresa.id;

      this.$isLoading(true);
      try {
        await this.getFecha(
          empresaId,
          this.currentFilterDateFormatted.anio,
          this.currentFilterDateFormatted.mes
        );
        await this.getProfesionales(
          empresaId,
          this.currentFilterDateFormatted.anio,
          this.currentFilterDateFormatted.mes
        );
      } catch (error) {
        console.error("Error al filtrar los datos:", error);
        Swal.fire(
          "Error!",
          "No se pudieron cargar los datos filtrados.",
          "error"
        );
      }
      this.$isLoading(false);
    },
    initDataTable() {
      this.dataTableInstance = window.$("#datatable_profesionales").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
        destroy: true, // Asegura que se pueda reinicializar correctamente
        responsive: true,
      });
    },
    generateReport() {
      // Preparar los datos en un arreglo de arreglos (AOA)
      const ws_data = [
        [
          "Cédula",
          "Profesional",
          "Correo",
          "Período",
          "Documentos cargados",
          "Cuenta de cobro",
          "Estado",
        ],
      ];

      this.listProfesionales.forEach((item) => {
        const profesional = `${item.Nombres} ${item.Apellidos}`;
        const correo = item.Correo;
        const fecha =
          item.Periodo !== "-"
            ? this.$moment(item.Periodo, "YYYY-MM").format("MMMM, YYYY")
            : "No hay datos";
        const archivos = item.ArchivosCargados ? "Sí" : "No";
        const cdc = item.IsUploadedCC ? "Sí" : "No";
        const estado = item.Estado == 1 ? "Completado" : "Pendiente";
        ws_data.push([
          item.NumeroDocumento,
          profesional,
          correo,
          fecha,
          archivos,
          cdc,
          estado,
        ]);
      });

      // Crear la hoja de cálculo a partir de los datos
      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      // Crear un nuevo libro de Excel y agregar la hoja
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");

      // Generar y descargar el archivo XLSX
      XLSX.writeFile(wb, "reporte_profesionales.xlsx");
    },

    async ToggleIsUploadCuentaCobro() {
      try {
        const { id } = this.ultimaFecha;
        const res = await this.$store.dispatch("hl_put", {
          path: `CDC/ToggleIsUploadCuentaCobro/${id}`,
        });

        //console.log(res);

        if (res) this.ultimaFecha.isUploadCuentaCobro = res.data;
      } catch (error) {
        console.error("Error al guardar cambios:", error);
        Swal.fire("Error!", "No se pudieron guardar los cambios.", "error");
      }
    },
    async saveNewDate() {
      try {
        this.$isLoading(true);

        this.nuevaFecha.empresaId = this.personaAct.empresa.id;

        const res = await this.$store.dispatch("hl_post", {
          path: "CDC/AddFecha",
          data: this.nuevaFecha,
        });

        //console.log(res);
        if (res.id) {
          this.ultimaFecha = res;
          Swal.fire("Listo!", "Nueva fecha habilitada con éxito.", "success");

          await this.getProfesionales(
            this.personaAct.empresa.id,
            res.anio,
            res.mes
          );
        }
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.error("Error al guardar cambios:", error);
        Swal.fire("Error!", "No se pudieron guardar los cambios.", "error");
      }
    },
    async actualizarFechaFin() {
      //console.log(this.ultimaFecha);
      //console.log(this.nuevaFecha);

      try {
        this.$isLoading(true);
        const res = await this.$store.dispatch("hl_put", {
          path: "CDC/UpdateFechaFin",
          data: {
            id: this.ultimaFecha.id,
            fechaFin: this.nuevaFecha.fechaFin,
            createdAt: this.nuevaFecha.createdAt,
          },
        });
        //console.log(res);

        if (res.id) {
          // Actualizamos el valor original con el valor nuevo
          this.ultimaFecha.fechaFin = res.fechaFin;
          this.ultimaFecha.createdAt = res.createdAt;
          Swal.fire(
            "¡Actualizado!",
            "La fecha de cierre se actualizó correctamente.",
            "success"
          );
        } else {
          Swal.fire(
            "Error",
            "No se pudo actualizar la fecha de cierre.",
            "error"
          );
        }
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.error("Error al actualizar la fecha fin:", error);
        Swal.fire(
          "Error",
          "No se pudo actualizar la fecha de cierre.",
          "error"
        );
      }
    },
    handleDateInput(event) {
      const [anio, mes] = event.target.value.split("-");
      this.nuevaFecha.anio = anio;
      this.nuevaFecha.mes = mes;
      //console.log(this.nuevaFecha);
    },
    async getFecha(empresaId, anio, mes) {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetFecha/${empresaId}/${anio}/${mes}`,
        });
        if (response.ok) {
          const allData = await response.json();
          //console.log(allData.data);
          if (allData.data) {
            this.ultimaFecha = allData.data;
            this.fechaCargaHabilitada = allData.data;

            this.currentDate = `${this.ultimaFecha.anio}-${String(
              this.ultimaFecha.mes
            ).padStart(2, "0")}`;
            this.nuevaFecha.fechaInicio = this.$moment
              .tz(this.ultimaFecha.fechaInicio, "America/Bogota")
              .format("YYYY-MM-DDTHH:mm");
            this.nuevaFecha.fechaFin = this.$moment
              .tz(this.ultimaFecha.fechaFin, "America/Bogota")
              .format("YYYY-MM-DDTHH:mm");

            // Reiniciar cuenta regresiva cuando cambie la fecha
            this.iniciarCuentaRegresiva();
          }
        } else {
          this.ultimaFecha = {};
          this.fechaCargaHabilitada = null;
          this.currentDate = null;
          this.nuevaFecha.fechaInicio = null;
          this.nuevaFecha.fechaFin = null;
        }
      } catch (error) {
        console.error("Error en getProfesionales:", error);
      }
    },
    async getProfesionales(empresaId, anio, mes) {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetProfesionales/${empresaId}/${anio}/${mes}`,
        });

        if (response.ok) {
          const allData = await response.json();
          this.listProfesionales = allData.data;

          //console.log(this.listProfesionales);
        }
      } catch (error) {
        console.error("Error en getProfesionales:", error);
        this.listProfesionales = [];
      } finally {
        if (this.dataTableInstance) {
          this.dataTableInstance.destroy();
        }

        this.$nextTick(() => {
          this.initDataTable();
        });
      }
    },
  },
};
</script>
<style scoped>
.loading-msg {
  text-align: center;
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.div-comentario {
  width: 250px;
}
.div-comentario-v2 {
  width: auto;
}
.accordion-title {
  background-color: var(--gray-100);
  padding: 10px;
  cursor: pointer;
  border: 1px solid var(--gray-100);
  margin: 5px 0;
}

.accordion-content {
  padding: 10px;
  border: 1px solid var(--gray-100);
  background-color: var(--gray-100);
}
.card-header {
  cursor: pointer;
}
.accordion-item {
  margin-top: 10px;
}

/* Contenedor del filtro */
.filter-container {
  width: 100%;
  position: relative;
}

/* Estilos para la cuenta regresiva en auditoría */
.countdown-header {
  display: flex;
  align-items: center;
  background: var(--gray-100);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.8;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 160px; /* Ancho fijo para evitar movimientos */
  text-align: center; /* Centrar el contenido */
  justify-content: center; /* Centrar los elementos flex */
}

.countdown-text {
  font-weight: 600;
}

@media (max-width: 768px) {
  .countdown-header {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
}

/* Animación de pulso */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
}
/* Ajuste de altura personalizada para el modal */
.modal-altura-personalizada .modal-dialog {
  max-height: 80vh;
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-altura-personalizada .modal-content {
  overflow-y: auto;
}

/* Estilo para lista de comentarios */
.comentarios-cuenta-cobro .list-group-item {
  padding: 15px;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 10px;
  transition: all 0.3s ease-in-out;
}

.comentarios-cuenta-cobro .list-group-item:hover {
  background-color: #e8f0fe;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* Detalle flotante */
.detalle-flotante {
  /* background: white; */
  /* border: 1px solid #ddd;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); */
  border-radius: 5px;
  padding: 10px;
  width: auto;
  z-index: 10;
  top: 80%;
  left: 65%;
  transform: translateY(10px);
}
.notification {
  font-size: 18px; /* Tamaño del icono ajustado a 18px */
  color: #ffffff; /* Color del icono */
  animation: shake 1s ease-in-out infinite;
  transform-origin: top center; /* El punto de rotación ahora es la parte superior */
}

@keyframes shake {
  0% {
    transform: rotate(0deg) translateX(0);
  }
  20% {
    transform: rotate(10deg) translateX(5px);
  }
  40% {
    transform: rotate(-10deg) translateX(-5px);
  }
  60% {
    transform: rotate(5deg) translateX(3px);
  }
  80% {
    transform: rotate(-5deg) translateX(-3px);
  }
  100% {
    transform: rotate(0deg) translateX(0);
  }
}
</style>
